// Polyfills navigateur pour Anchor / web3.js (qui supposent un env Node).
// DOIT être importé en TOUT PREMIER, avant @coral-xyz/anchor et @solana/web3.js,
// pour que Buffer/process existent au moment où ces modules s'évaluent.
import { Buffer } from "buffer";

const g = globalThis as any;
if (!g.Buffer) g.Buffer = Buffer;
if (!g.global) g.global = globalThis;
if (!g.process) g.process = { env: {}, browser: true, version: "" };
